import {
  formItemTypeEnum,
  matchModeEnum,
  operatorEnum,
} from '@sttedra_ui/framework';

const checkboxProperties = {
  binary: true,
  truValue: true,
  falseValue: false,
};
const customChipClassification = (f) => !!f.value ? 'verdadero' : 'falso';

export const POI_SCHEMA = [
  {
    field: 'name',
    label: 'Nombre',
  },
  {
    field: 'province',
    label: 'Provincia',
  },
  {
    field: 'town',
    label: 'Municipio',
  },
  {
    field: 'category',
    label: 'Categoría',
    sortable: false,
  },
];

export const POI_FILTERS = [
  {
    field: 'balne',
    label: 'Balnearios',
    icon: 'pool',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-spa',
    ],
  },
  {
    field: 'cast',
    label: 'Castillos y murallas',
    icon: 'castle',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-castle',
    ],
  },
  {
    field: 'cr',
    label: 'Casas rurales',
    icon: 'cottage',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-cottage',
    ],
  },
  {
    field: 'cueva',
    label: 'Cuevas prehistóricas y naturales',
    icon: 'fence',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-cave',
    ],
  },
  {
    field: 'erm',
    label: 'Iglesias, capillas y colegiatas',
    icon: 'church',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-hermitage',
    ],
  },
  {
    field: 'jardin',
    label: 'Jardines',
    icon: 'yard',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-garden',
    ],
  },
  {
    field: 'monas',
    label: 'Monasterios',
    icon: 'location_city',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-monastery',
    ],
  },
  {
    field: 'monum',
    label: 'Monumentos civiles',
    icon: 'museum',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-monument',
    ],
  },
  {
    field: 'ruinas',
    label: 'Ruinas y yacimientos',
    icon: 'elderly',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-ruin',
    ],
  },
];
